<template>
  <div class="note-container" :id="`note-${id}`">
    <div class="note-data">
      <div class="note-date">{{formattedDate}}</div>
      <div class="note-title">{{title}}</div>
      <div class="note-body" v-html="contentParsed"></div>
    </div>
    <div class="note-button"><a :href="link_url">{{link_text}}</a></div>
  </div>
</template>

<script>
import moment from 'moment';
import propIdMixin from '@/views/prop-id-mixin';
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import contentDataLoaderMixin from '@/store/modules/contentData/content-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import * as parserRegexes from '@/views/content-parser-regexes';

export default {
	mixins: [propIdMixin, staticDataLoaderMixin, contentDataLoaderMixin, featureSetLoaderMixin],
	props: {
		id: Number,
		title: String,
		content: String,
		date: String,
		link_text: String,
		link_url: String,
		scrollToId: Number,
	},
	mounted() {
		if (this.scrollToId === this.id && this.featureSet.postsView.scrollToClosestDatePost) {
			this.$root.$emit('onMountedScrollTo', this.scrollToId);
		}
	},
	computed: {
		formattedDate() {
			if (this.date) {
				let langCode = '';
				this.languageList.forEach((lang) => {
					if (lang.name === this.language) {
						langCode = lang.code;
					}
				});
				return moment.utc(this.date).local().locale(langCode).format('ll');
			}
			return '';
		},
		contentParsed() {
			let newContent = this.content;
			Object.keys(parserRegexes).forEach((pName) => {
				newContent = newContent.replace(parserRegexes[pName], '');
			});
			return newContent;
		},
	},
};
</script>

<style src="@/styles/components/NoteContentThumbnail/NoteContentThumbnail.less" lang="less" scoped></style>
